import * as React from "react";

export function useComposedEventHandlers<
  EventType extends { defaultPrevented: boolean },
>(...handlers: (GenericEventHandler<EventType> | null | undefined)[]) {
  return React.useMemo(() => composeEventHandlers(...handlers), [...handlers]);
}

function composeEventHandlers<EventType extends { defaultPrevented: boolean }>(
  ...handlers: (GenericEventHandler<EventType> | null | undefined)[]
) {
  return (event: EventType) => {
    let previousHandler: GenericEventHandler<EventType> | null | undefined;
    for (const handler of handlers) {
      previousHandler?.(event);
      if (!event.defaultPrevented) {
        handler?.(event);
      }
      previousHandler = handler;
    }
  };
}

type GenericEventHandler<EventType extends { defaultPrevented: boolean }> = (
  event: EventType,
) => void;
